import React, { useState } from 'react'

import useFirebase from 'hooks/firebase'

import {
  Backdrop,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemText,
  TextField,
  Typography,
} from '@mui/material'

import EditIcon from '@mui/icons-material/Edit'
import PersonRemoveIcon from '@mui/icons-material/PersonRemove'

import LoadingButton from '@mui/lab/LoadingButton'

const PersonalInformation = (props) => {
  const { collection, deleting, onDelete, profile } = props

  const { firestore, functions } = useFirebase()
  const { updateDocFromCollection } = firestore
  const { updateUserEmail } = functions

  const [open, setOpen] = useState(false)

  const [edit, setEdit] = useState('')

  const [email, setEmail] = useState(profile.email)
  const handleEmailChanged = (event) => {
    setEmail(event.target.value)
  }

  const [firstName, setFirstName] = useState(profile.firstName)
  const handleFirstNameChanged = (event) => {
    setFirstName(event.target.value)
  }

  const [fathersLastName, setFathersLastName] = useState(profile.fathersLastName)
  const handleFathersLastNameChanged = (event) => {
    setFathersLastName(event.target.value)
  }
  
  const [mothersLastName, setMothersLastName] = useState(profile.mothersLastName)
  const handleMothersLastNameChanged = (event) => {
    setMothersLastName(event.target.value)
  }

  const updateEmail = async () => {
    const data = {
      'email': email,
    }

    await updateUserEmail({ 'email': email, 'uid': profile.id })

    await updateDocFromCollection('users', profile.id, data)
    await updateDocFromCollection(collection, profile.id, data)
  }

  const updateName = async () => {
    const data = {
      'firstName': firstName,
      'fathersLastName': fathersLastName,
      'mothersLastName': mothersLastName,
      'name': `${firstName} ${fathersLastName}`
    }
    await updateDocFromCollection('users', profile.id, data)
    await updateDocFromCollection(collection, profile.id, data)
  }

  const onEdit = async () => {
    setOpen(true)
    if (edit === 'email') {
      await updateEmail()
    }

    if (edit === 'name') {
      await updateName()
    }

    setEdit('')
    setOpen(false)
  }

  const onCancel = () => {
    if (edit === 'email') setEmail(profile.email)
    if (edit === 'name') {
      setFirstName(profile.firstName)
      setFathersLastName(profile.fathersLastName)
      setMothersLastName(profile.mothersLastName)
    }
    setEdit('')
  }

  const [openDialog, setOpenDialog] = useState(false)
  const handleClose = () => {
    setOpenDialog(false)
  }

  const onDeleteProfile = () => {
    setOpenDialog(false)
    onDelete()
  }

  return (
    <Card sx={{ borderRadius: 2, p: 2 }}>
      <CardContent sx={{ p: 0, '&:last-child': { paddingBottom: 0 } }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography color='primary' variant='body1'>
              <b style={{ fontWeight: 900 }}>INFORMACIÓN PERSONAL</b>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <List disablePadding>
              {
                edit === 'name' ? (
                  <ListItem sx={{ p: 0, py: 2 }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextField
                          value={firstName}
                          onChange={handleFirstNameChanged}
                          placeholder='Ingresa el nombre'
                          label='Nombre'
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                          sx={{ flexGrow: 1 }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          value={fathersLastName}
                          onChange={handleFathersLastNameChanged}
                          placeholder='Ingresa el apellido paterno'
                          label='Apellido paterno'
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                          sx={{ flexGrow: 1 }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          value={mothersLastName}
                          onChange={handleMothersLastNameChanged}
                          placeholder='Ingresa el apellido materno'
                          label='Apellido materno'
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                          sx={{ flexGrow: 1 }}
                        />
                      </Grid>
                      <Grid item xs={12} align='right'>
                        <Button color='lightPurple' disableElevation variant='contained' onClick={onCancel}>
                          <b>Cancelar</b>
                        </Button>
                        <Button color='lightGreen' disableElevation variant='contained' sx={{ ml: 1 }} onClick={onEdit}>
                          <b>Guardar</b>
                        </Button>
                      </Grid>
                    </Grid>
                  </ListItem>
                ) : (
                  <ListItem
                    secondaryAction={
                      <IconButton edge='end' size='small' onClick={() => setEdit('name')}>
                        <EditIcon color='lightPurple' fontSize='small' />
                      </IconButton>
                    } 
                    sx={{ p: 0 }}
                  >
                    <ListItemText primary={<b>Nombre</b>} secondary={profile.name} />
                  </ListItem>
                )
              }
              {
                edit === 'email' ? (
                  <ListItem sx={{ p: 0, py: 2 }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <TextField
                          value={email}
                          onChange={handleEmailChanged}
                          placeholder='Ingresa el email'
                          label='Email'
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                          sx={{ flexGrow: 1 }}
                        />
                      </Grid>
                      <Grid item xs={12} align='right'>
                        <Button color='lightPurple' disableElevation variant='contained' onClick={onCancel}>
                          <b>Cancelar</b>
                        </Button>
                        <Button color='lightGreen' disableElevation variant='contained' sx={{ ml: 1 }} onClick={onEdit}>
                          <b>Guardar</b>
                        </Button>
                      </Grid>
                    </Grid>
                  </ListItem>
                ) : (
                  <ListItem 
                    secondaryAction={
                      <IconButton edge='end' size='small' onClick={() => setEdit('email')}>
                        <EditIcon color='lightPurple' fontSize='small' />
                      </IconButton>
                    } 
                    sx={{ p: 0 }}
                  >
                    <ListItemText primary={<b>Email</b>} secondary={profile.email} />
                  </ListItem>
                )
              }
            </List>
          </Grid>
          <Grid item xs={12}>
            <LoadingButton color='warningRed' fullWidth disableElevation loading={deleting} loadingPosition='start' startIcon={<PersonRemoveIcon />} variant='contained' onClick={() => setOpenDialog(true)}>
              <b style={{ fontWeight: 900 }}>{ deleting ? 'BORRANDO PERFIL' : 'BORRAR PERFIL' }</b>
            </LoadingButton>
          </Grid>
        </Grid>
      </CardContent>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color='inherit' />
      </Backdrop>
      <Dialog
        open={openDialog}
        onClose={handleClose}
      >
        <DialogTitle>
          ¿Estás seguro de borrar el perfil?
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Esta acción no puede deshacerse
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}><b style={{ fontWeight: 900 }}>CANCELAR</b></Button>
          <Button color='warningRed' variant='contained' disableElevation onClick={onDeleteProfile} autoFocus>
            <b style={{ fontWeight: 900 }}>BORRAR</b>
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  )
}

export default PersonalInformation